import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-layout-wrapper gfu-layout-wrapper--narrow _pb-6 js-main-content" }
const _hoisted_2 = { class: "gfu-box gfu-box--flat gfu-box--huge _my-6 gfu-bt gfu-bt--b1 _tac" }
const _hoisted_3 = { class: "_mt-6" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_footer_navigation = _resolveComponent("footer-navigation")
  const _component_external_link = _resolveComponent("external-link")
  const _component_base_hero = _resolveComponent("base-hero")
  const _component_marketing_services_benefits = _resolveComponent("marketing-services-benefits")
  const _component_marketing_services_values = _resolveComponent("marketing-services-values")
  const _component_testimonials_slider = _resolveComponent("testimonials-slider")
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_footer_navigation, {
      "current-page": _ctx.Resources.Layout.MarketingServicesLink
    }, null, 8 /* PROPS */, ["current-page"]),
    _createVNode(_component_base_hero, {
      title: `${$options.platformName} Performance Team`,
      type: "marketing"
    }, {
      description: _withCtx(() => [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "gfu-become-creator-hero__content _mb-6" }, [
          _createTextVNode(" Boost your project's reach with our expert team. "),
          _createElementVNode("br"),
          _createTextVNode(" We'll manage your promotion across Facebook, Instagram, Messenger, Threads, Google, and Reddit - from campaign preview to pledge manager. ")
        ], -1 /* CACHED */)),
        _createVNode(_component_external_link, {
          href: $props.contactUrl,
          class: "gfu-btn gfu-btn--accent gfu-btn--soft gfu-btn--wide _tac"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Complete the form ", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["href"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["title"]),
    _createElementVNode("main", _hoisted_1, [
      _createVNode(_component_marketing_services_benefits, { "marketing-services-benefits": $props.marketingServicesBenefits }, null, 8 /* PROPS */, ["marketing-services-benefits"]),
      _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "gfu-hd gfu-hd--h1" }, "Marketing services", -1 /* CACHED */)),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "gfu-bt gfu-bt--b1 _mb-6" }, "Bring your project the attention it deserves.", -1 /* CACHED */)),
      _createVNode(_component_marketing_services_values, { "marketing-services-values": $props.marketingServicesValues }, null, 8 /* PROPS */, ["marketing-services-values"]),
      _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "gfu-hd gfu-hd--h1 _my-6" }, "They trusted us", -1 /* CACHED */)),
      _createVNode(_component_testimonials_slider, {
        testimonials: $props.testimonials,
        page: "MarketingServices"
      }, null, 8 /* PROPS */, ["testimonials"]),
      _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "gfu-hd gfu-hd--h1 _mb-6" }, "Reach out", -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_base_icon, {
          name: "envelope",
          size: "4x",
          class: "_tc--accent _mb-6"
        }),
        _cache[3] || (_cache[3] = _createElementVNode("div", null, "Contact us for a custom marketing plan for your project.", -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_external_link, {
            href: $props.contactUrl,
            class: "gfu-btn gfu-btn--primary gfu-btn--soft gfu-btn--wide _tac"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" Get personalized offer ", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["href"])
        ])
      ])
    ])
  ]))
}